import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from "firebase/app"
import 'firebase/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Acceuil',
    component() { return import('../views/Index.vue')},
    meta: {
      icon: 'mdi-home',
    },
  },
  {
    path: '/dashboard',
    name: 'Moniteur',
    component() { return import('../views/Dashboard.vue')},
    meta: {
      icon: 'mdi-view-dashboard',
      requiredClaims: ['admin'],
    },
  },
  {
    path: '/vault',
    name: 'Archives',
    component() { return import('../views/Vault.vue')},
    meta: {
      icon: 'mdi-safe-square',
      requiredClaims: ['admin'],
    },
  },
  {
    path: '/ventes',
    name: 'Dpt Ventes',
    component() { return import('../views/SalesTools.vue')},
    meta: {
      icon: 'mdi-sale',
      requiredClaims: ['admin', 'sales'],
    },
  },
  {
    path: '/blog',
    name: 'Blog',
    component() { return import('../views/Blog.vue')},
    meta: {
      icon: 'mdi-post',
      requiredClaims: ['admin'],
    },
  },
  {
    path: '/landing-pages',
    name: 'Landing Pages',
    component() { return import('../views/LandingPages.vue')},
    meta: {
      icon: 'mdi-web',
      requiredClaims: ['admin'],
    },
  },
  {
    path: '/resources',
    name: 'Ressources',
    component() { return import('../views/Resources.vue')},
    meta: {
      icon: 'mdi-flask-outline',
      requiredClaims: ['admin'],
    },
  },
  {
    path: '/users',
    name: 'Gestion des utilisateurs',
    component() { return import('../views/Users.vue')},
    meta: {
      icon: 'mdi-account-multiple',
      requiredClaims: ['admin'],
    },
  },
  {
    path: '*',
    name: 'not-found',
    component() { return import('../views/404NotFound.vue')},
    meta: {},
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(userAuth => {
    //Si la page requiert un rôle en particulier
    if (to.matched.some(record => Boolean(record.meta.requiredClaims))) {
      if(userAuth !== null) {
        userAuth.getIdTokenResult()
        .then(function ({ claims }) {
          //Page admin
          if(to.matched[0].meta.requiredClaims.indexOf('admin') > -1 && Boolean(claims.admin)) next()
          //Autre page contrôlée
          else if(to.matched[0].meta.requiredClaims.length > 0 && Boolean(claims.user_id)) next()
          //Aucun claim requis (l'array est probablement vide)
          else next()
        })
      }
      //Expulser si un rôle est requis et que l'utilisateur n'est pas authentifié
      else next({ path: '/' })
    }
    //Si la page ne requiert pas un rôle en particulier
    else if (from.name !== null) next()
    /* else next({ path: '/' }) */
    //else console.log(from.name)
  })
})

export default router